import { send as sendMetric } from '@playcastdotio/Metrics';
import type { PlaycastMetricHostInstallDownload, PlaycastMetricPayload, PlaycastMetricPlayerHostLink } from '@playcastdotio/Metrics';
import config from '@playcastdotio/GlobalConfig';
import { cookie } from '@playcastdotio/Cookie';
import { createPlayerPersistentId } from '@playcastdotio/CreateId';

export const getPersistentPlayerId = () => {
  const { get, set } = cookie();
  const id = get('playcast-player-id') || localStorage.getItem('playcast-player-id');
  if (id) return id;
  const searchParams = new URLSearchParams(window.location.search);
  const playerId = searchParams.get('id');
  if (playerId) {
    set('playcast-player-id', playerId);
    localStorage.setItem('playcast-player-id', playerId);
    return playerId;
  } else {
    const newId = createPlayerPersistentId();
    set('playcast-player-id', newId);
    localStorage.setItem('playcast-player-id', newId);
    return newId;
  }
};

// wrapper to include the persistentId and auth token in the headers for metrics requests
const send = async (data: PlaycastMetricPayload): Promise<boolean> => {
  const persistentId = getPersistentPlayerId();
  const headers = {
    persistentId,
  };
  try {
    await sendMetric(data, headers);
    return true;
  } catch (e) {
    console.error('[METRICS] Failed to send metric', e);
    return false;
  }
};

export const sendMetricHostInstallDownload = (userAgent: string, ipAddress: string) => {
  const persistentId = getPersistentPlayerId();
  const data: PlaycastMetricHostInstallDownload = {
    name: 'host-install-download',
    version: config.VERSION,
    environment: config.ENVIRONMENT,
    userAgent,
    ipAddress,
    persistentId,
  };
  return send(data);
};

export const sendMetricPlayerHostLink = (userId: string) => {
  const persistentId = getPersistentPlayerId();
  const data: PlaycastMetricPlayerHostLink = {
    name: 'player-host-link',
    version: config.VERSION,
    environment: config.ENVIRONMENT,
    hostAuthId: userId,
    persistentId,
  };
  return send(data);
};
